<template>
  <div>
    <div id="card">
      <!-- 門市資訊 -->
      <div style="position: relative; margin-bottom: 10px;">
        <el-table style="margin: 0 auto; width: 100%; position: fixed; top: 70px;"
          :data="storeList.filter(el => el[1].userShow !== false)"
          key="store"
          :height="height"
          :empty-text="$t('Member.no_data')">
          <el-table-column
            prop="Store"
            :label="$t('Member.store')">
            <template slot-scope="scope">
              <span>
                <div>{{ $t('Member.store_name') }}: {{ scope.row[0] || $t('Member.no_data') }}</div>
                <div>{{ $t('Member.address') }}: {{ scope.row[1] ? scope.row[1].Address : $t('Member.no_data') }}</div>
                <div>{{ $t('Member.phone') }}:
                  <span v-if="scope.row[1] && scope.row[1].truePhone">
                    <a style="color: #4267b2; font-size: 15px;" :href="`tel:${getPhone(scope.row[1])}`">{{ scope.row[1] ? scope.row[1].truePhone : $t('Member.no_data') }}</a>
                  </span>
                  <span v-else>{{ $t('Member.no_provide') }}</span>
                </div>
              </span>
            </template>
          </el-table-column>
          <el-table-column width="110"
            prop="LINE"
            label="LINE@">
            <template slot-scope="scope">
              <span>
                <a :href="scope.row[1] ? scope.row[1].LINE : 'https://www.eilis-ai.com/'" target="blank">
                  <img v-if="scope.row[1] && scope.row[1].LINE" src="https://img.vogue.com.tw/_rs/960/userfiles/FCK/2018092862618633.png" width="95%">
                </a>
                <span v-if="scope.row[1] && !scope.row[1].LINE">{{ $t('Member.no_provide') }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueBarcode from 'vue-barcode';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
    };
  },
  props: ['logo', 'only', 'height'],
  computed: {
    ...mapGetters({
      storeList: 'storeList'
    })
  },
  methods: {
    col() {
      if (!this.logo || this.only) {
        return 24;
      }
      return 12;
    },
    OfficialSite() {
      window.open('https://www.eilis-ai.com/');
    },
    getPhone(val) {
      if (val) {
        return val.truePhone;
      }
      return '00000000';
    }
  }
}
</script>

<style scoped>
  #card {
    width: 100%;
    max-width: 550px;
    margin: 0 auto;
    overflow: hidden;
    border-radius: 5px;
  }
  .web {
    text-decoration: none;
    color: #888;
    transition: 0.2s;
    font-size: 13px;
  }
</style>